// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__GYVmm","itemTitle":"styles_itemTitle__FdzC_","expandIcon":"styles_expandIcon__1SHf5","itemText":"styles_itemText__Nvtnw"};